// Generated by Melange

import * as LucideReact__Icon from "./icon.jsx";

const CirclePause = LucideReact__Icon;

const CirclePlay = LucideReact__Icon;

const Download = LucideReact__Icon;

const EarOff = LucideReact__Icon;

const Ellipsis = LucideReact__Icon;

const Heart = LucideReact__Icon;

const Home = LucideReact__Icon;

const Info = LucideReact__Icon;

const KeyRound = LucideReact__Icon;

const Loader2 = LucideReact__Icon;

const LogOut = LucideReact__Icon;

const ListEnd = LucideReact__Icon;

const ListMusic = LucideReact__Icon;

const ListPlus = LucideReact__Icon;

const ListStart = LucideReact__Icon;

const Menu = LucideReact__Icon;

const Pause = LucideReact__Icon;

const Play = LucideReact__Icon;

const Repeat = LucideReact__Icon;

const Repeat1 = LucideReact__Icon;

const SkipBack = LucideReact__Icon;

const SkipForward = LucideReact__Icon;

const SlidersVertical = LucideReact__Icon;

const Trash2 = LucideReact__Icon;

const Volume1 = LucideReact__Icon;

const Volume2 = LucideReact__Icon;

const VolumeX = LucideReact__Icon;

const X = LucideReact__Icon;

export {
  CirclePause,
  CirclePlay,
  Download,
  EarOff,
  Ellipsis,
  Heart,
  Home,
  Info,
  KeyRound,
  Loader2,
  LogOut,
  ListEnd,
  ListMusic,
  ListPlus,
  ListStart,
  Menu,
  Pause,
  Play,
  Repeat,
  Repeat1,
  SkipBack,
  SkipForward,
  SlidersVertical,
  Trash2,
  Volume1,
  Volume2,
  VolumeX,
  X,
}
/* No side effect */
